import type { SyncStatus } from '@/features/sync/useSync'

/**
 * Status dot colour.
 *
 * Offline is deliberately neutral rather than a warning: the app works fully
 * offline, so colouring it as a problem would be misleading.
 */
export function syncDot(status: SyncStatus): 'ok' | 'warn' | 'error' | 'idle' {
  if (status === 'idle') return 'ok'
  if (status === 'unauthorized') return 'error'
  if (status === 'error') return 'warn'
  return 'idle'
}
